import {
    faBookAtlas,
    faEarthAmericas,
    faHandshake,
    faHome,
    faHomeUser,
    faMessage,
    faRightToBracket,
    faSignOut,
    faUsers
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

import classes from "./MainNavigation.module.css";

function MainNavigation(props) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(prev => !prev);
    };

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "auto";
    }, [isOpen]);

    return (
        <header>
            <div className={`interface ${classes.interface}`}>

                {/* LOGO */}
                <div className={classes.logo}>
                    <Link to="/">
                        <img src="/img/logo.png" alt="Logo" />
                    </Link>
                </div>

                {/* MENU DESKTOP */}
                <nav className={classes.menuDesktop}>
                    <ul>
                        {!props.isLoggedIn && (
                            <>
                                <li><Link to="/servicos">SERVIÇOS</Link></li>
                                <li><Link to="/portfolio">PORTFOLIO</Link></li>
                                <li><Link to="/contato">CONTATO</Link></li>
                            </>
                        )}

                        {props.isLoggedIn && (
                            <li>
                                <Link to="/admin">
                                    <h3>
                                        <FontAwesomeIcon icon={faHome} />&nbsp;ÁREA ADMINISTRATIVA
                                    </h3>
                                </Link>
                            </li>
                        )}
                    </ul>
                </nav>

                {/* LOGIN / LOGOUT */}
                {!props.isLoggedIn ? (
                    <div className={classes.btnContato}>
                        <Link to="/login">
                            <button>
                                <FontAwesomeIcon icon={faUsers} />&nbsp;LOGIN
                            </button>
                        </Link>
                    </div>
                ) : (
                    <div className={classes.btnContato}>
                        <button onClick={props.onLogout}>
                            <FontAwesomeIcon icon={faSignOut} />&nbsp;LOGOUT
                        </button>
                    </div>
                )}

                {/* BOTÃO MOBILE */}
                <div className={classes.btnAbrirMenu}>
                    <i className="bi bi-list" onClick={toggleMenu}></i>
                </div>

                {/* MENU MOBILE */}
                <div className={`${classes.menuMobile} ${isOpen ? classes.abrirMenu : ''}`}>

                    <div className={classes.btnFechar}>
                        <i className="bi bi-x-lg" onClick={toggleMenu}></i>
                    </div>

                    <nav>
                        <ul>
                            {!props.isLoggedIn && (
                                <>
                                    <li>
                                        <Link to="/" onClick={toggleMenu} className={classes.menuItem}>
                                            <FontAwesomeIcon icon={faHome} />
                                            <span>INÍCIO</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/servicos" onClick={toggleMenu} className={classes.menuItem}>
                                            <FontAwesomeIcon icon={faHandshake} />
                                            <span>SERVIÇOS</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/portfolio" onClick={toggleMenu} className={classes.menuItem}>
                                            <FontAwesomeIcon icon={faBookAtlas} />
                                            <span>PORTFOLIO</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/contato" onClick={toggleMenu} className={classes.menuItem}>
                                            <FontAwesomeIcon icon={faMessage} />
                                            <span>CONTATO</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to="/login" onClick={toggleMenu} className={classes.menuItem}>
                                            <FontAwesomeIcon icon={faRightToBracket} />
                                            <span>LOGIN</span>
                                        </Link>
                                    </li>                                    
                                </>
                            )}

                            {props.isLoggedIn && (
                                <>
                                    <li>
                                        <Link to="/admin" onClick={toggleMenu} className={classes.menuItem}>
                                            <FontAwesomeIcon icon={faEarthAmericas} />
                                            <span>ÁREA ADMINISTRATIVA</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <button
                                            className={classes.menuItem}
                                            onClick={() => {
                                                toggleMenu();
                                                props.onLogout();
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faSignOut} />
                                            <span>LOGOUT</span>
                                        </button>
                                    </li>
                                </>
                            )}
                        </ul>
                    </nav>

                </div>

                {/* OVERLAY */}
                <div
                    className={`${classes.overlayMenu} ${isOpen ? classes.active : ''}`}
                    onClick={toggleMenu}
                ></div>

            </div>
        </header>
    );
}

export default MainNavigation;